import React from "react";
import * as Yup from "yup";
import { REQUIRED_FIELD_MESSAGE } from "../../../../../CONSTANTS";
import { useMutation } from "react-query";
import { addOperator } from "../../../../../api/operator/operatorApi";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import ImagesModal from "../../../lib/ImagesModal";
import UserForm from "../UserForm";

// Form Field validations
const userValidationSchema = Yup.object().shape({
    mobile: Yup.string().min(9,"mobile must be at least 11 characters").max(10,"mobile must be at least 11 characters").required(REQUIRED_FIELD_MESSAGE),
    usernameC: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    passwordC: Yup.string().min(8, 'Password must be at least 8 characters').required(REQUIRED_FIELD_MESSAGE),
    confirmPassword: Yup.string().oneOf([Yup.ref('passwordC')], 'Passwords must match').required(REQUIRED_FIELD_MESSAGE),
    f_name: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    l_name: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    email: Yup.string().email().required(REQUIRED_FIELD_MESSAGE),
    role: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    group: Yup.string().required(REQUIRED_FIELD_MESSAGE),
  });


// Form initial values
const initialValues = {
    mobile: "",
    usernameC: "",
    passwordC: "",
    confirmPassword: "",
    f_name: "",
    l_name: "",
    nationalCode: "",
    personalCode: "",
    email: "",
    role: "",
    group: "",
    imageId: "",
    imageName: "",
    activation: 1,
  };

// Form Labels
const labels = { sendBtnLabel: "ارسال" };

/* Main Component */
function AddUser() {


    // React Query -> use For Create Operator Api 
    const mutation = useMutation((operator: any) => addOperator(operator));

    /* Image States And functions */
    // Image State
    const [showImages, setShowImages] = React.useState<boolean>(false);
    //Image Close and Open show functions
    const closeShowImagesModal = () => setShowImages(false);
    const openShowImagesModal = () => setShowImages(true);

    //Formik library -> config for create operator
    const formik = useFormik({
      initialValues,
      validationSchema: userValidationSchema,
        enableReinitialize:true,
      onSubmit: async (values) => {
        const {
            mobile,
            usernameC,
            passwordC,
            confirmPassword,
            f_name,
            l_name,
            personalCode,
            nationalCode,
            email,
            role,
            group,
            activation,
        } = values;

        const operator = {
            mobile : mobile.toString(),
           username: usernameC,
           password: passwordC,
            confirmPassword,
            f_name,
            l_name,
            personalCode: personalCode.toString(),
            nationalCode: nationalCode.toString(),
            email,
            roleId : role,
            group,
            image: values.imageId?values.imageId :null,
            activation: activation || 1,
        };
        mutation.mutate(operator);
      },
    });

    /* Api Response Messages */
    // Message -> Error
    if (mutation.isError &&formik.isValid) {
        toast.error("اشکال در ارسال", { position: "top-center" });
    }
    
    // Message -> Success
    if (mutation.isSuccess) {
        toast.success("کارشناس با موفقیت ایجاد شد", { position: "top-center" });
        formik.resetForm();
        mutation.reset();
    }
    
    return(
        <div className={""}>
            <div className={"card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between bg-white" +
                " pt-5"}>
                <h2>کارشناس جدید</h2>
            </div>
            <UserForm
                formik={formik}
                openShowImagesModal={openShowImagesModal}
                labels={labels}
            />

        </div>
    )
}

export default AddUser
